export default __webpack_public_path__ + "static/media/82.cacb039d.png";